import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

const GOLD = '#B8860B';

export default function WaitlistConfirmed() {
  const navigate = useNavigate();

  const handleFinish = async () => {
    await signOut(auth);
    navigate('/'); // Send them back to the landing page
  };

  return (
    <div style={containerStyle}>
      <div style={glowStyle} />
      <div style={cardStyle}>
        <div style={iconContainer}>
          <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="1.5">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>

        <h1 style={titleStyle}>EMAIL VERIFIED</h1>
        <p style={subtitleStyle}>
          Thank you for joining the <span style={{ color: GOLD }}>ESDRAS Waitlist</span>.
        </p>

        <div style={statusBox}>
          <p style={statusText}>
            Your identity has been confirmed. Your profile is now in our secure queue. 
            <br /><br />
            <strong>NEXT STEP:</strong> Please await a formal approval email from our team to complete your biometric registration.
          </p>
        </div>

        <button onClick={handleFinish} style={primaryBtn}>
          RETURN TO HOMEPAGE
        </button>
        
        <p style={closeNote}>You may now safely close this browser window.</p>
      </div>
    </div>
  );
}

// Reuse your existing styles or reference these:
const containerStyle = { minHeight: '100vh', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', position: 'relative', overflow: 'hidden', fontFamily: 'Inter, sans-serif' };
const glowStyle = { position: 'absolute', width: '400px', height: '400px', background: GOLD, opacity: 0.05, filter: 'blur(100px)', borderRadius: '50%' };
const cardStyle = { width: '100%', maxWidth: '400px', textAlign: 'center', zIndex: 1 };
const iconContainer = { marginBottom: '30px' };
const titleStyle = { color: '#FFF', fontSize: '1.5rem', letterSpacing: '4px', fontWeight: '900' };
const subtitleStyle = { color: '#888', fontSize: '0.9rem', marginBottom: '30px' };
const statusBox = { background: '#0a1219', border: '1px solid #1a2631', padding: '25px', borderRadius: '15px', marginBottom: '30px' };
const statusText = { color: '#ccc', fontSize: '0.8rem', lineHeight: '1.8', margin: 0 };
const primaryBtn = { background: GOLD, color: '#000', border: 'none', padding: '16px', borderRadius: '50px', fontWeight: '900', fontSize: '0.75rem', letterSpacing: '1px', cursor: 'pointer', width: '100%' };
const closeNote = { marginTop: '20px', color: '#444', fontSize: '0.65rem', letterSpacing: '1px' };
